var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
define(["require", "exports", "hypo_elements/Typescripts/UrlParameters/UrlParameters", "./OfficeService", "hypo_bvo/Drklein/Shared/AgentService", "jquery"], function (require, exports, UrlParameters_1, OfficeService_1, AgentService_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.assembleAgentFromOfficeAllocation = exports.storeOfficeAllocation = exports.getOfficeAllocationFromServer = exports.getOfficeAllocationForAgent = exports.getNearbyOfficeAllocation = void 0;
    var STORAGE_PATH_OFFICE_ALLOCATION = "hypoport.agent-storage.agent-office-allocation";
    function getProductGroupPlatformId() {
        return window.hypoport.produktsparte.toUpperCase();
    }
    function getNearbyOfficeAllocation() {
        var deferred = $.Deferred();
        function resolvePromise(result) {
            if (result && result.agent && result.agent.profileImageUrls) {
                updateProfileImageUrls(result).then(function (result) {
                    storeOfficeAllocation(result);
                    deferred.resolve(result);
                }).fail(function (result) {
                    deferred.resolve(result);
                });
            }
            else {
                deferred.resolve(result);
            }
        }
        var preferredAgentId = (0, UrlParameters_1.getQueryParameterByName)("wunschberater");
        if (!preferredAgentId) {
            preferredAgentId = (0, UrlParameters_1.getQueryParameterByName)("beraterExtern");
        }
        if (preferredAgentId) {
            //if the parameter "wunschberater" is set and contains an agentId, load that agent
            getOfficeAllocationFromParameterWithPlatformId(preferredAgentId).done(resolvePromise).fail(function () {
                //if the parameter "wunschberater" is set but the id is not an agentId, maybe it is a typo3Id, try to find the corresponding agent
                // @ts-ignore
                getOfficeAllocationFromParameterWithTypo3Id(preferredAgentId).done(resolvePromise).fail(function () {
                    loadOfficeAllocationFromStorageOrServer().done(resolvePromise).fail(function () {
                        deferred.reject();
                    });
                });
            });
        }
        else {
            loadOfficeAllocationFromStorageOrServer().done(resolvePromise).fail(function () {
                deferred.reject();
            });
        }
        return deferred.promise();
    }
    exports.getNearbyOfficeAllocation = getNearbyOfficeAllocation;
    function loadOfficeAllocationFromStorageOrServer() {
        var deferred = $.Deferred();
        function resolvePromise(result) {
            deferred.resolve(result);
        }
        //if no agent could be found from the parameter "wunschberater", try to load an agent from the localStorage if the site was previously visited
        getOfficeAllocationFromStorage().done(resolvePromise).fail(function () {
            //this is a migration because the format of the object in localstorage changed, so if there is still an agent in the old format, load that
            migrateOfficeAllocationFromOldStorage().done(resolvePromise).fail(function () {
                //if no officeAllocation could be found, load a new random one from server
                getOfficeAllocationFromServer().done(resolvePromise).fail(function () { return deferred.reject(); });
            });
        });
        return deferred.promise();
    }
    function migrateOfficeAllocationFromOldStorage() {
        var deferred = $.Deferred();
        var storagePath = getOriginalStoragePath();
        var bueroFromStorage = sessionStorage.getItem(storagePath);
        if (!bueroFromStorage) {
            bueroFromStorage = localStorage.getItem(storagePath);
        }
        if (bueroFromStorage) {
            var beraterId = JSON.parse(bueroFromStorage).berater[0].uid;
            if (beraterId) {
                getOfficeAllocationFromParameterWithTypo3Id(beraterId).done(function (result) { return deferred.resolve(result); });
            }
            sessionStorage.removeItem(storagePath);
        }
        else {
            deferred.reject();
        }
        return deferred.promise();
    }
    /**
     * try to find an agent with the given platform agent id
     * @param preferredAgentId
     */
    function getOfficeAllocationFromParameterWithPlatformId(preferredAgentId) {
        var deferred = $.Deferred();
        (0, AgentService_1.getAgent)(preferredAgentId).done(function (agent) {
            var officeAllocation = getOfficeAllocationForAgent(agent);
            storeOfficeAllocation(officeAllocation);
            deferred.resolve(officeAllocation);
        }).fail(function () {
            deferred.reject();
        });
        return deferred.promise();
    }
    /**
     * try to find an agent with the given typo3 id
     * @param preferedAgentId
     */
    function getOfficeAllocationFromParameterWithTypo3Id(preferedAgentId) {
        var deferred = $.Deferred();
        $.getJSON("index.php?id=1480&type=6666&tx_hypobvo_beraterprofilseite[uid]=" + preferedAgentId, function (beraterJSON) {
            if (beraterJSON.id) {
                (0, AgentService_1.getAgent)(beraterJSON.id).done(function (agent) {
                    var officeAllocation = getOfficeAllocationForAgent(agent);
                    storeOfficeAllocation(officeAllocation);
                    deferred.resolve(officeAllocation);
                });
            }
            else {
                deferred.reject();
            }
        });
        return deferred.promise();
    }
    function getOfficeAllocationForAgent(agent) {
        var officeId = (0, UrlParameters_1.getQueryParameterByName)("wunschbuero");
        var officeIndex = 0;
        if (officeId) {
            for (var i = 0; i < agent.officeAllocations.length; i++) {
                if (agent.officeAllocations[i]._embedded.office.id == officeId) {
                    officeIndex = i;
                }
            }
        }
        var oa = agent.officeAllocations[officeIndex];
        agent.phoneNumber = oa.phoneNumber;
        agent.faxNumber = oa.faxNumber;
        return { agent: agent, office: oa._embedded.office };
    }
    exports.getOfficeAllocationForAgent = getOfficeAllocationForAgent;
    function getCurrentStoragePath() {
        return STORAGE_PATH_OFFICE_ALLOCATION + "." + getProductGroupPlatformId();
    }
    function getOriginalStoragePath() {
        return "hypoport.berater-storage.berater-buero." + window.hypoport.produktsparte;
    }
    function getOfficeAllocationFromStorage() {
        var deferred = $.Deferred();
        var officeAllocationFromLocalStorage = localStorage.getItem(getCurrentStoragePath());
        if (officeAllocationFromLocalStorage) {
            deferred.resolve(JSON.parse(officeAllocationFromLocalStorage));
            return deferred.promise();
        }
        var officeAllocationFromSessionStorage = sessionStorage.getItem(getCurrentStoragePath());
        if (officeAllocationFromSessionStorage) {
            deferred.resolve(JSON.parse(officeAllocationFromSessionStorage));
            return deferred.promise();
        }
        deferred.reject();
        return deferred.promise();
    }
    function getOfficeAllocationFromServer() {
        var deferred = $.Deferred();
        new Promise(function (resolve_1, reject_1) { require(["hypo_elements/Typescripts/Geolocation/Geolocation"], resolve_1, reject_1); }).then(__importStar).then(function (geolocation) {
            geolocation.getGeolocation().then(function (geolocation) {
                $.get({
                    url: (0, OfficeService_1.getOfficesPath)(),
                    data: {
                        latitude: geolocation.latitude,
                        longitude: geolocation.longitude,
                        sort: 'distance',
                        agentWithAnyProductGroupPlatformId: getProductGroupPlatformId(),
                        employeeTagExternalKeys: 'show_card'
                    },
                }).then(function (officePageResource) {
                    var offices = officePageResource._embedded.offices;
                    var agent;
                    var office;
                    // @ts-ignore
                    for (var j = 0; j < offices.length && !agent; j++) {
                        var officeAllocations = officePageResource._embedded.offices[j]._embedded.officeAllocations;
                        office = officePageResource._embedded.offices[j];
                        // @ts-ignore
                        for (var i = 0; i < officeAllocations.length && !agent; i++) {
                            var productGroups = officeAllocations[i]._embedded.agent.productGroupPlatformIds;
                            var agentEmployeeTags = officeAllocations[i]._embedded.agent.employeeTags;
                            if (productGroups.includes(getProductGroupPlatformId()) && agentEmployeeTags.includes('show_card')) {
                                agent = assembleAgentFromOfficeAllocation(officeAllocations[i]);
                            }
                        }
                    }
                    // @ts-ignore
                    var officeAllocation = { agent: agent, office: office };
                    storeOfficeAllocation(officeAllocation);
                    deferred.resolve(officeAllocation);
                })
                    .fail(function () { return deferred.reject(); });
            });
        });
        return deferred.promise();
    }
    exports.getOfficeAllocationFromServer = getOfficeAllocationFromServer;
    function storeOfficeAllocation(officeAllocation) {
        sessionStorage.setItem(getCurrentStoragePath(), JSON.stringify(officeAllocation));
        localStorage.setItem(getCurrentStoragePath(), JSON.stringify(officeAllocation));
        localStorage.removeItem(getOriginalStoragePath());
        sessionStorage.removeItem(getOriginalStoragePath());
    }
    exports.storeOfficeAllocation = storeOfficeAllocation;
    function assembleAgentFromOfficeAllocation(oa) {
        var agent = (0, AgentService_1.assembleAgent)(oa._embedded.agent);
        agent.phoneNumber = oa.phoneNumber;
        agent.faxNumber = oa.faxNumber;
        return agent;
    }
    exports.assembleAgentFromOfficeAllocation = assembleAgentFromOfficeAllocation;
    function updateProfileImageUrls(result) {
        var deferred = $.Deferred();
        if (result.agent.profileImageUrls["ORIGINAL"].indexOf("/ORIGINAL/") !== -1 &&
            result.agent.profileImageUrls["THUMBNAIL"].indexOf("/THUMBNAIL/") !== -1) {
            deferred.resolve(result);
        }
        else {
            $.getJSON(result.agent._links.self.href, function (agent) {
                if (agent && agent.profileImageUrls) {
                    result.agent.profileImageUrls = agent.profileImageUrls;
                }
                deferred.resolve(result);
            }).fail(function () {
                deferred.reject(result);
            });
        }
        return deferred.promise();
    }
});
